/** Default trial length for new org signups (days). */
export const TRIAL_DAYS_DEFAULT = 14;
/** Days after `past_due` before hard-locking product access. */
export const PAST_DUE_GRACE_DAYS = 3;
export const VALID_PLANS = ['starter', 'pro', 'enterprise'];
export const SUBSCRIPTION_STATUSES = [
    'none',
    'trialing',
    'active',
    'past_due',
    'canceled',
    'unpaid',
];
export const PRACTICE_SESSION_USAGE_MODES = ['tier_default', 'unlimited', 'custom_cap'];
/** Feature flag keys granted per commercial plan (before subscription-status rules). */
export const TIER_FEATURES = {
    starter: [],
    pro: ['multi_persona', 'crm_connect'],
    enterprise: [
        'multi_persona',
        'multi_user',
        'practice_scheduling',
        'crm_connect',
        'crm_deal_personas',
    ],
};
/** Org-wide practice sessions per UTC calendar month when mode is tier_default. */
export const USAGE_LIMITS = {
    starter: 30,
    pro: 150,
    enterprise: 1000,
};
//# sourceMappingURL=index.js.map